import { CategoryPageTemplate } from './CategoryPageTemplate'

export function BodyAestheticPage() {
  return <CategoryPageTemplate categoryKey="bodyAesthetic" namespace="bodyAesthetic" />
}
